﻿import { Component, Input } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import {ValidationMessage} from '../../validation/validationMessage';
import {ValidationMessageType} from '../../validation/validationMessageType';

@Component({
    selector: 'jax-validation-panel',
    templateUrl: './validationPanel.component.html',
    inputs: ['validationMessage']
})

export class ValidationPanelComponent {

    validationClass: string;
    validationMessageField: ValidationMessage;

    constructor(private sanitizer: DomSanitizer) { }

    public getSafeHTML(message:string) {
        return this.sanitizer.bypassSecurityTrustHtml(message);
    }

    set validationMessage(value: ValidationMessage) {
        if (value) {
            if (value.messageType === ValidationMessageType.Error)
                this.validationClass = 'alert-danger';
            if (value.messageType === ValidationMessageType.Info)
                this.validationClass = 'alert-info';
            if (value.messageType === ValidationMessageType.Warning)
                this.validationClass = 'alert-warn';
            if (value.messageType === ValidationMessageType.Ok)
                this.validationClass = 'alert-success';
        }
        this.validationMessageField = value;
    }

    get validationMessage(): ValidationMessage {
        return this.validationMessageField;
    }
}